var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"meniu-contul-meu"},[_c('div',{staticClass:"nav nav-tabs"},[_c('div',{staticClass:"link-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/contul-meu"}},[_c('span',{staticClass:"menu-item-text"},[_vm._v("Setari cont")])])],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }